// extracted by mini-css-extract-plugin
export var bgrImage = "Section-module--bgrImage--e1565";
export var dark = "Section-module--dark--a6311";
export var full = "Section-module--full--693cd";
export var none = "Section-module--none--4115c";
export var paddingBottom = "Section-module--paddingBottom--8e735";
export var paddingDefault = "Section-module--paddingDefault--6ce58";
export var paddingTop = "Section-module--paddingTop--62983";
export var section = "Section-module--section--2b6fd";
export var section__bgrImg = "Section-module--section__bgrImg--cce2f";
export var section__content = "Section-module--section__content--e516e";
export var section__inner = "Section-module--section__inner--b486d";
export var section__title = "Section-module--section__title--f06ac";
export var transparent = "Section-module--transparent--0ef56";